import { render, staticRenderFns } from "./SvlpComponentBannerText.vue?vue&type=template&id=00b6cf0d&scoped=true"
import script from "./SvlpComponentBannerText.vue?vue&type=script&lang=js"
export * from "./SvlpComponentBannerText.vue?vue&type=script&lang=js"
import style0 from "./SvlpComponentBannerText.vue?vue&type=style&index=0&id=00b6cf0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b6cf0d",
  null
  
)

export default component.exports